import { ReactNode } from 'react';

import clsxm from '@/lib/clsxm';

import MarkdownBlock from '../Chat/MarkdownBlock';
export const Tooltip = ({
  message,
  className,
  children,
}: {
  message: string;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <div className='group relative flex flex-col items-center'>
      {children}
      <div
        className={clsxm(
          'absolute bottom-0 left-0 mb-6 flex hidden w-64 flex-col items-center group-hover:flex',
          className
        )}
      >
        <span className='whitespace-no-wrap leading-1 relative z-[999] rounded-md bg-gray-600 p-2 text-xs text-white shadow-lg'>
          <MarkdownBlock message={message} />
        </span>
      </div>
    </div>
  );
};
